import { RenderTexture } from '../renderer';
import { nextPow2 } from '../math';

const TILE_STRIDE = 129; // 1 count + 128 max light indices

export class TileDataTexture {
  readonly texture: RenderTexture;
  private capacity = 0;

  constructor(private gl: WebGL2RenderingContext) {
    this.texture = new RenderTexture();
    this.texture.glTexture = gl.createTexture()!;
  }

  update(tileData: Float32Array, numTiles: number): void {
    const gl = this.gl;
    if (numTiles === 0) return;

    if (numTiles > this.capacity) {
      this.capacity = nextPow2(numTiles);

      gl.bindTexture(gl.TEXTURE_2D, this.texture.glTexture!);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.R32F, TILE_STRIDE, this.capacity, 0, gl.RED, gl.FLOAT, null);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    }

    gl.bindTexture(gl.TEXTURE_2D, this.texture.glTexture!);
    gl.texSubImage2D(
      gl.TEXTURE_2D,
      0,
      0,
      0,
      TILE_STRIDE,
      numTiles,
      gl.RED,
      gl.FLOAT,
      tileData.subarray(0, numTiles * TILE_STRIDE),
    );
  }

  destroy(): void {
    if (this.texture.glTexture) {
      this.gl.deleteTexture(this.texture.glTexture);
    }
  }
}
